import type { ErrorMessages } from '@repo/types/messages/errors';

import { ErrorCodes } from '#errorCodes';

import { quizErrorMessages } from './quizErrorMessages';

export const quizBuilderErrorMessages: ErrorMessages = {
  ...quizErrorMessages,
  [ErrorCodes.FORBIDDEN.QUIZ.ANSWER_INVALIDATION]: {
    title: 'Nie można unieważnić odpowiedzi',
    detail: 'Istnieją zarejestrowane próby tego quizu. Po weryfikacji obecnych odpowiedzi co najmniej jedna z nich stanie się nieprawidłowa',
  },
};
